<template>
    <div id="app">
        <v-container fluid pa-0>
            <v-layout row wrap>
                <v-flex md2 xs12 pa-0 pr-3>
                    <v-card flat dark color="transparent">
                        <Sports @setSport="selectSport" :connection="connection"></Sports>
                    </v-card>
                </v-flex>
                <v-flex md7 xs12 pa-0 class="full-height">
                    <v-card flat color="grey darken-3">
                        <v-card-text class="px-0 py-0">
                            <BetOptions :sport="sport" :connection="connection"></BetOptions>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex md3 xs12 pa-0 pl-3>
                    <v-card flat dark color="transparent">
                        <!--<Widget></Widget>-->
                        <BetSlip :connection="connection"></BetSlip>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import Sports from './components/Sports.vue';
    import Widget from './components/Widget.vue';
    import BetSlip from './components/BetSlip.vue';
    import BetOptions from './components/BetOptions.vue';
    import { HubConnectionBuilder } from "@aspnet/signalr";
    import { setInterval } from 'timers';
    import * as CONFIG from './config'

    export default {
        name: 'app',
        components: {
            Sports,
            Widget,
            BetSlip,
            BetOptions
        },
        data() {
            return {
                connection: null,
                sport: ''
            }
        },
        methods: {
            selectSport: function (selectedSport) {
                this.sport = selectedSport;
            }
        },
        created() {
            if (this.$route.query.token !== undefined) {
                this.$store.dispatch('login', { authToken: this.$route.query.token }).then(() => { });
            }
            this.connection = new HubConnectionBuilder()
                .withUrl(CONFIG.SIGNALR_HUB)
                .build();
            this.connection.start();
        },
        mounted() {
            setInterval(() => {
                // if the user has a token - and 20 minutes has passed - renew the token.
                if (this.$store.getters.accessToken) {
                    this.$store.dispatch('login', { authToken: this.$store.getters.accessToken }).then(() => { });
                }
            }, 1200000)
        },
        beforeDestroy() {
            console.log('beforeDestroy');
            this.connection.stop();
        }
    };
</script>

<style>
    * {
        box-sizing: border-box;
    }

    html {
        overflow: scroll;
        overflow-x: hidden;
    }

    html, body {
        height: 100%;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    body {
        background-color: #0a0a0a;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
    }

    .application--wrap {
        min-height: inherit !important;
    }

    img, svg {
        max-width: 100%;
    }

    .application--wrap {
        min-height: 100% !important;
    }

    .v-tabs__slider.accent {
        border-color: #fff !important;
        background-color: #fff !important;
    }

    li.blue.darken-4 {
        background-color: #004369 !important;
    }

    ::-webkit-scrollbar {
        width: 0px;
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background: #D3D3D3;
    }

    .odds-select .v-menu__content {
        top: 5px !important;
        left: 0px !important;
    }

    .success {
        background-color: #4caf50 !important;
        border-color: #4caf50 !important;
    }

    .error {
        background-color: #ff5252 !important;
        border-color: #ff5252 !important;
    }

    /* Latest Media Queries For Responsive View Bryan */
    @media (max-width: 959px) {
        .flex.md6.xs12.pa-0.pr-3, .flex.md3.xs12.pa-0.pr-3 {
            padding-right: 0 !important;
        }

        .flex.md3.xs12.pa-0.pl-3, .flex.md3.xs12.pa-0.pl-3 {
            padding-left: 0px !important;
        }

        .betSlip button.btn-submit.v-btn.v-btn--disabled.theme--dark.blue--text .v-btn__content {
            white-space: nowrap !important;
        }
        .betSlip button.btn-submit.v-btn.theme--dark.blue .v-btn__content {
            white-space: nowrap !important;
        }
    }
    .betSlip .v-alert{
        width: 100%;
    }

    .tooltip {
        display: block !important;
        z-index: 10000;
    }

    .tooltip .tooltip-inner {
        background: black;
        color: white;
        border-radius: 16px;
        padding: 5px 10px 4px;
    }

    .tooltip .tooltip-arrow {
        width: 0;
        height: 0;
        border-style: solid;
        position: absolute;
        margin: 5px;
        border-color: black;
        z-index: 1;
    }

    .tooltip[x-placement^="top"] {
        margin-bottom: 5px;
    }

    .tooltip[x-placement^="top"] .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
    }

    .tooltip[x-placement^="bottom"] {
        margin-top: 5px;
    }

    .tooltip[x-placement^="bottom"] .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
    }

    .tooltip[x-placement^="right"] {
        margin-left: 5px;
    }

    .tooltip[x-placement^="right"] .tooltip-arrow {
        border-width: 5px 5px 5px 0;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
    }

    .tooltip[x-placement^="left"] {
        margin-right: 5px;
    }

    .tooltip[x-placement^="left"] .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
    }

    .tooltip.popover .popover-inner {
        background: #f9f9f9;
        color: black;
        padding: 24px;
        border-radius: 5px;
        box-shadow: 0 5px 30px rgba(0,0,0, .1);
    }

    .tooltip.popover .popover-arrow {
        border-color: #f9f9f9;
    }

    .tooltip[aria-hidden='true'] {
        visibility: hidden;
        opacity: 0;
        transition: opacity .15s, visibility .15s;
    }

    .tooltip[aria-hidden='false'] {
        visibility: visible;
        opacity: 1;
        transition: opacity .15s;
    }

    @media (max-width:959px) {
        #app .container.fluid.pa-0 .layout.row.wrap .flex.md2.xs12.pa-0.pr-3 {
            padding-right: 0 !important;
        }
    }

    .full-white-border {
        border: 1px solid #fff;
    }

    .border .v-text-field .v-input__control {
        font-size: 14px;
    }

    .border .v-text-field__slot input {
        margin-top: 13px;
        max-height: 21px;
    }

    .border .v-text-field .v-input__slot {
        min-height: 20px !important;
    }

    .border .v-text-field .v-label {
        font-size: 12px;
        top: 8px;
    }

    .footer .v-menu .v-list__tile__title {
        font-size: 12px !important;
    }

    .border .theme--dark.v-text-field > .v-input__control > .v-input__slot:before,
    .border .theme--dark.v-text-field > .v-input__control > .v-input__slot:hover:before,
    .theme--dark.v-text-field:not(.v-input--has-state) > .v-input__control > .v-input__slot:hover:before {
        border: none !important;
    }
    /*
        Betslip IE

    */
    _:-ms-fullscreen, :root .border .v-text-field__slot input:disabled {
        margin-top: 5px;
        max-height: 25px;
    }

    @media screen and (min-width:0\0) and (min-resolution: +72dpi) {
        .border .v-text-field__slot input:disabled {
            margin-top: 5px;
            max-height: 25px;
        }
    }
</style>
